import { alpha, SxProps, Theme } from "@mui/material";
import { HSV_BRAND_COLORS } from "../../theme/common";
import { MatchDayColorScheme } from "../../types/Settings";

export const matchDayStyles: SxProps<Theme> = {
    mt: 8,
    mb: 12,
};

const COLOR_SCHEMES: Record<
    MatchDayColorScheme,
    { background: string; text: string; textShadow: string }
> = {
    dark: {
        background: alpha(HSV_BRAND_COLORS.black, 0.8),
        text: HSV_BRAND_COLORS.white,
        textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
    },
    light: {
        background: alpha(HSV_BRAND_COLORS.white, 0.9),
        text: HSV_BRAND_COLORS.black,
        textShadow: "none",
    },
};

// Text color and heading shadow are set here and inherited by the texts in the box
export const matchDayBackgroundStyles = (
    colorScheme: MatchDayColorScheme
): SxProps<Theme> => {
    const { background, text, textShadow } = COLOR_SCHEMES[colorScheme];
    return {
        background,
        color: text,
        textShadow,
        minHeight: "300px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderTop: `4px solid ${text}`,
        borderBottom: `4px solid ${text}`,
    };
};

export const matchDayContentStyles: SxProps<Theme> = {
    zIndex: 2,
    textAlign: "center",
    padding: "40px 20px",
    width: "100%",
};

export const welcomeTextStyles: SxProps<Theme> = {
    fontWeight: "bold",
    marginBottom: "32px",
    fontSize: { xs: "1.6rem", md: "2.2rem" },
};

export const teamsContainerStyles: SxProps<Theme> = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "32px",
    marginBottom: "16px",
    flexWrap: "wrap",
};

export const teamLogoStyles: SxProps<Theme> = {
    width: { xs: "80px", md: "100px" },
    height: { xs: "80px", md: "100px" },
};

export const vsTextStyles: SxProps<Theme> = {
    fontWeight: "bold",
    fontSize: { xs: "2rem", md: "3rem" },
};

export const matchSubtitleStyles: SxProps<Theme> = {
    textShadow: "none",
    fontWeight: "bold",
    textAlign: "center",
    mt: 2,
    fontSize: { xs: "1.2rem", md: "1.4rem" },
};

export const loadingStyles: SxProps<Theme> = {
    textShadow: "none",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1rem",
};

export const errorStyles: SxProps<Theme> = {
    textShadow: "none",
    textAlign: "center",
    fontSize: "1rem",
    opacity: 0.8,
};
